// Libraries
import React from 'react'
import PropTypes from 'prop-types'

// PropTypes and DefaultProps
const defaultProps = {
  width: '32px',
  height: '32px',
  color: '',
}

const propTypes = {
  width: PropTypes.string,
  height: PropTypes.string,
  color: PropTypes.string,
}

// Component
function IconNotificationEcwt({ width, height }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 37.058 38.721"
    >
      <g transform="translate(-10.998 0)">
        <path
          fill="#2a428c"
          d="M45.52,49.886a18.529,18.529,0,1,0-31.985,0Z"
          transform="translate(0 -20.332)"
        />
        <path
          fill="#d3dcfb"
          d="M69.087,0H53.463c-.087,0-.175,0-.261.007-.567.243-1.925,1.1-1.925,3.739V5.793a1.543,1.543,0,0,1-1.542,1.542H47.444c-2.456,0-3.257,1.311-3.493,1.9-.006.1-.009.193-.009.29V29.477a18.622,18.622,0,0,0,5.429,5.907V14.828a5,5,0,0,1,1.453-3.508l4.438-4.438A4.929,4.929,0,0,1,58.77,5.429H70.71V1.623A1.623,1.623,0,0,0,69.087,0Z"
          transform="translate(-30.453 0)"
        />
        <path
          fill="#bec8f7"
          d="M53.463,0c-.087,0-.175,0-.261.007-.567.243-1.925,1.1-1.925,3.739V5.793a1.543,1.543,0,0,1-1.542,1.542H47.444c-2.456,0-3.257,1.311-3.493,1.9-.006.1-.009.193-.009.29V29.477a18.622,18.622,0,0,0,5.429,5.907V14.828a5,5,0,0,1,1.453-3.508l4.241-4.241a5.241,5.241,0,0,1-.274-2.012v-3.4C54.79.3,56.53,0,56.53,0H53.463Z"
          transform="translate(-30.453 0)"
        />
        <path
          fill="#d3dcfb"
          d="M49.87,1.489A5.082,5.082,0,0,1,53.464,0s-2.105.457-2.105,3.745V5.793a1.622,1.622,0,0,1-1.623,1.622H47.445c-3.113,0-3.5,2.105-3.5,2.105a5.083,5.083,0,0,1,1.489-3.594Z"
          transform="translate(-30.453 0)"
        />
        <path
          fill="#73c3f9"
          d="M322.9,36.9a.324.324,0,0,0-.324.324v1.99a.324.324,0,0,0,.324.324h5.371V36.9Z"
          transform="translate(-288.015 -34.106)"
        />
        <path
          fill="#4fabf7"
          d="M325.23,38.215a1.319,1.319,0,0,1,1.319-1.319H322.9a.324.324,0,0,0-.324.324v1.99a.324.324,0,0,0,.324.324h3.649A1.319,1.319,0,0,1,325.23,38.215Z"
          transform="translate(-288.014 -34.106)"
        />
        <path
          fill="#e8f4fc"
          d="M140.886,71.8a1.623,1.623,0,0,0-1.623-1.623H123.639c-.087,0-.175,0-.261.007-.567.243-1.925,1.1-1.925,3.739v2.048a1.543,1.543,0,0,1-1.542,1.542H117.62c-2.456,0-3.257,1.311-3.493,1.9-.006.1-.009.193-.009.29v20.472a18.535,18.535,0,0,0,26.768-5.823Z"
          transform="translate(-95.321 -64.869)"
        />
        <path
          fill="#d3dcfb"
          d="M124.639,72.966a3,3,0,0,1,1.789-2.79h-2.789c-.087,0-.175,0-.261.007-.567.243-1.925,1.1-1.925,3.738v2.048a1.543,1.543,0,0,1-1.542,1.542H117.62c-2.456,0-3.257,1.311-3.493,1.9-.006.1-.009.193-.009.29v20.472a18.445,18.445,0,0,0,10.73,3.421q.505,0,1-.027a2.7,2.7,0,0,1-1.027-1.927V98.687c0-1.437,1.751-1.739,1.751-1.739V88.153a2.3,2.3,0,0,1-1.937-2.433Z"
          transform="translate(-95.321 -64.869)"
        />
        <path
          fill="#ff4155"
          d="M171.649,308.283v5.2a1.978,1.978,0,0,0,1.977,1.977h14.111a1.977,1.977,0,0,0,1.977-1.977v-5.2a1.977,1.977,0,0,0-1.977-1.977H173.626A1.977,1.977,0,0,0,171.649,308.283Z"
          transform="translate(-148.501 -283.141)"
        />
        <path
          fill="#e80054"
          d="M178.455,313.488v-5.2a1.977,1.977,0,0,1,1.977-1.977h-6.807a1.977,1.977,0,0,0-1.977,1.977v5.2a1.978,1.978,0,0,0,1.977,1.977h6.807A1.977,1.977,0,0,1,178.455,313.488Z"
          transform="translate(-148.501 -283.141)"
        />
        <path
          fill="#e8f4fc"
          d="M256.163,331.541l-.007-.017a.7.7,0,0,0-.649-.435h0a.7.7,0,0,0-.649.436l-.005.014-1.576,4.139a.606.606,0,0,0,1.133.432l.244-.64h1.7l.241.639a.606.606,0,1,0,1.135-.428Zm-1.047,2.716.39-1.023.386,1.023Z"
          transform="translate(-223.919 -306.05)"
        />
        <path
          fill="#e8f4fc"
          d="M319.426,336.242a.606.606,0,1,0,.992-.7l-1.336-1.9,1.128-1.6a.606.606,0,0,0-.992-.7l-.878,1.246-.876-1.245a.606.606,0,0,0-.992.7l1.126,1.6-1.338,1.9a.606.606,0,0,0,.992.7l1.088-1.544Z"
          transform="translate(-282.074 -306.049)"
        />
        <path
          fill="#e8f4fc"
          d="M212.53,331.7a.607.607,0,0,0-.606-.606h-2.318a.606.606,0,1,0,0,1.213h.548v3.592a.606.606,0,1,0,1.213,0V332.3h.557A.606.606,0,0,0,212.53,331.7Z"
          transform="translate(-183.027 -306.05)"
        />
        <g transform="translate(23.354 14.973)">
          <path
            fill="#bec8f7"
            d="M214.184,199.2H224.7a.606.606,0,1,0,0-1.213H214.184a.606.606,0,1,0,0,1.213Z"
            transform="translate(-210.613 -197.985)"
          />
          <path
            fill="#bec8f7"
            d="M174.977,230.041h16.441a.606.606,0,1,0,0-1.213H174.977a.606.606,0,1,0,0,1.213Z"
            transform="translate(-174.371 -226.495)"
          />
          <path
            fill="#bec8f7"
            d="M191.419,259.672H174.977a.606.606,0,1,0,0,1.213h16.441a.606.606,0,1,0,0-1.213Z"
            transform="translate(-174.371 -255.007)"
          />
        </g>
        <path
          fill="#d3dcfb"
          d="M358.3,455.118h-2.138a.606.606,0,0,0,0,1.213H358.3a.606.606,0,0,0,0-1.213Z"
          transform="translate(-318.497 -420.698)"
        />
        <g transform="translate(39.869 8.098)">
          <path
            fill="#73c3f9"
            d="M393.077,107.072a.324.324,0,0,0-.324.324v1.99a.324.324,0,0,0,.324.324h5.371v-2.638Z"
            transform="translate(-392.753 -107.072)"
          />
        </g>
        <path
          fill="#4fabf7"
          d="M395.407,108.391a1.319,1.319,0,0,1,1.319-1.319h-3.649a.324.324,0,0,0-.324.324v1.99a.324.324,0,0,0,.324.324h3.649A1.319,1.319,0,0,1,395.407,108.391Z"
          transform="translate(-352.884 -98.974)"
        />
        <path
          fill="#e8f4fc"
          d="M120.045,71.665a5.082,5.082,0,0,1,3.594-1.489s-2.105.457-2.105,3.745v2.048a1.622,1.622,0,0,1-1.623,1.622H117.62c-3.113,0-3.5,2.105-3.5,2.105a5.082,5.082,0,0,1,1.489-3.594Z"
          transform="translate(-95.321 -64.869)"
        />
      </g>
    </svg>
  )
}

IconNotificationEcwt.defaultProps = defaultProps
IconNotificationEcwt.propTypes = propTypes

export default IconNotificationEcwt
